/**
 * Upload file to API
 * @param {Object} options
 * @param {File} options.field - Input field
 * @param {File} options.file - FileList item
 * @param {String} options.url - API endpoint
 * @param {Object} options.FormData - FormData implementation
 * @returns {Object}
 */
async function uploadFile(options = {}) {
	const { file, url, field } = options;

	if (!url) {
		return;
	}

	const formData = new FormData();

	formData.append('file', file);
	formData.append('field', field.name);
	formData.append('type', 'file');

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		body: formData,
		headers: {
			'X-Requested-With': 'XMLHttpRequest'
		}
	});
	const data = await response.json();

	return data;
}

/**
 * Rules
 */
const rules = {
	password: value => {
		const hasLength = value.length >= 12;
		const isNotExample = !['ichmaglegacynotes', 'jaimebienlegacynotes'].includes(
			value.toLowerCase().replace(/[^a-z]+/g, '')
		);
		const isValid = hasLength && isNotExample;

		return { isValid };
	},
	tel: async (value, options = {}) => {
		const result = await fetch(options.url, {
			method: 'POST',
			credentials: 'same-origin',
			body: JSON.stringify({
				value,
				type: 'tel'
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(response => response.json());

		return result;
	},
	file: async (value, options = {}) => {
		const files = options.field ? Array.from(options.field.files) : [];
		const results = await Promise.all(
			files.map(async file => {
				const data = await uploadFile({
					...options,
					file
				});

				return data;
			})
		);
		const isInvalid = results.find(result => !result.isValid);

		return isInvalid || results[0];
	},
	date: value => {
		const isValid = /^([0-9]{2}\.[0-9]{2}\.[0-9]{4}|[0-9]{4}-[0-9]{2}-[0-9]{2})$/.test(value);

		return { isValid };
	},
	calculator: data => {
		let isValid = true;

		try {
			const shares = JSON.parse(data || '{}').shares || [];
			const freeShare = shares.find(share => share.key === 'free');

			isValid = !freeShare || freeShare.value === 0;
		} catch (err) {
			console.log(err);
		}

		return { isValid };
	}
};

module.exports = rules;
